import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setAgreeWithLowDPIReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  state.isAgreeWithLowDPI = action.payload;
};

export default setAgreeWithLowDPIReducer;
